import Modal from '@rd-web-markets/shared/dist/util/Modal';
import React, { useState } from 'react';
import { Form, Card, Table } from 'react-bootstrap';
const BusinessUnitModal = _ref => {
  let {
    show,
    title,
    onHide,
    onSubmit
  } = _ref;
  const [businessUnit, setBusinessUnit] = useState({
    name: ''
  });
  const handleChange = event => {
    const value = event.target.value;
    setBusinessUnit({
      ...businessUnit,
      [event.target.name]: value
    });
  };
  const isInvalidName = businessUnit.name.length > 100;
  const modalBody = () => {
    return /*#__PURE__*/React.createElement(Card, {
      className: "mt-3"
    }, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Table, {
      className: "table-bordered"
    }, /*#__PURE__*/React.createElement("tbody", {
      "data-testid": "clientContactModalBody"
    }, /*#__PURE__*/React.createElement("tr", {
      className: "text-primary app-fs-table-header"
    }, /*#__PURE__*/React.createElement("th", {
      className: "border-0 font-weight-normal",
      style: {
        width: '20%'
      }
    }, "Name")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Form.Control, {
      value: businessUnit.name,
      name: "name",
      onChange: handleChange,
      size: "md",
      type: "text",
      isInvalid: isInvalidName
    }), /*#__PURE__*/React.createElement(Form.Control.Feedback, {
      type: "invalid"
    }, "Business Unit name should be less than 100 characters")))))));
  };
  return /*#__PURE__*/React.createElement(Modal, {
    size: "xl",
    title: title,
    show: show,
    renderBody: () => modalBody(),
    onHide: onHide,
    onSubmit: () => onSubmit(businessUnit),
    disabled: isInvalidName
  });
};
export default BusinessUnitModal;